import {motion} from 'framer-motion';
import React, {useEffect, useState} from 'react';
import s from './AutenticationStep.module.css'
import MyBtn from "../../../components/ui/MyBtn/MyBtn";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import {
    finalLoginThunk,
    getUserAccountListThunk,
    setTokenThunk,
    GetAccoutDetailsByAccountTypeThunk,
    setAccountsListTypesThunk,
    setChosenAccountTypeIdThunk, setSessionIdThunk, getLoginHistoryThunk, GetLimitsListThunk
} from "../../../store/reducers/ActionCreators";
import {useNavigate} from "react-router-dom";
import EmailAutenticationLogin
    from "../../../components/Autentications/EmailAutentication/EmailAutenticationLogin/EmailAutenticationLogin";
import {setDisabled} from "../../../store/reducers/UserSlice";
import SmsAuntification from "../../../components/Autentications/SmsAuntification/SmsAuntification";
import TwoFa from "../../../components/Autentications/TwoFa/TwoFa";
import {calculateCurrentDate} from "../../../helpers/CalculateDate";
import Steps from '../../../components/ui/Steps/Steps';
import CustomModal from "../../../components/ui/CustomModal/CustomModal";
import styles from "../../../components/ContactUsForm/ContactUsForm.module.css";
import close_circle from "../../../assets/img/personalAccount/close-circle.svg"

const AutenticationStep = (props: any) => {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [error, setError] = useState("")
    const [current, setCurrent] = useState(0);
    const [isErrorPopupOpen, setIsErrorPopupOpen] = useState(false);
    const [errorText, setErrorText] = useState("");
    const userToken = useAppSelector(store => store.userReducer.userToken)

    useEffect(() => {
        if (userToken !== "") {
            // Выполняем действия, когда userToken обновляется
            dispatch(getUserAccountListThunk(userToken))
                .then((res) => {
                    dispatch(setAccountsListTypesThunk(res.data));
                    if (res.data.length === 2) {
                        props.setAccountsList(res.data);
                        props.setCurrent(2);
                    } else if (res.data[0].activeStatus === false) {
                        setErrorText("Your account is inactive")
                        setIsErrorPopupOpen(true)
                    } else {
                        dispatch(setChosenAccountTypeIdThunk(res.data[0].id))
                        dispatch(getLoginHistoryThunk(userToken, calculateCurrentDate(), 1))
                        dispatch(GetAccoutDetailsByAccountTypeThunk(userToken, res.data[0].id))
                            .then((res) => {
                                if (res.data.flags.kycFormStatus !== "Approved") {
                                    dispatch(GetLimitsListThunk(userToken, res.data.userData.clientId));
                                    navigate("/personal-account/personal/settings");
                                } else {
                                    navigate('/personal-account/accounts')
                                }
                            })
                            .catch((e) => {
                                // неуместный кейс, так как проверка висит на степе выбора аккаунта? Уточнить у леши
                                if (e.response.date === "Error: Conflict") {
                                        setIsErrorPopupOpen(true)
                                        setErrorText('Oops, something went wrong. Please try again')
                                    // localStorage.clear()
                                    // localStorage.removeItem('persist:root')
                                    props.setDataForSend({
                                    email: '',
                                    password: '',
                                    emailCode: '',
                                    twoFaCode: '',
                                    smsCode: '',
                                    sessionStart: ''
                                })
                                    } else {
                                        console.log(e)
                                    }

                            })
                            .finally(() => {
                                dispatch(setDisabled(false))
                            })
                        ;
                    }
                });
        }
    }, [userToken, dispatch, props]);

    const sendLoginData = (e: any) => {

        e.preventDefault();

        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const preparedDataWithSessionStart = {
            ...props.dataForSend, userTimezone : timezone
        }

        dispatch(finalLoginThunk(preparedDataWithSessionStart))
            .then((res) => {
                dispatch(setTokenThunk(res.data.userToken));
                dispatch(setSessionIdThunk(res.data.sessionId));
            })
            .catch((e) => {
                for (let i = 0; i < props.validErrors.length; i++) {
                    if (props.validErrors[i] === e.response.data) {
                        setError(e.response.data)
                        break;
                    }
                    setError("Oops, something went wrong. Please try again later")
                }
                dispatch(setDisabled(false))

                if (e.response.data !== 'Invalid email code' //код email верный
                    && props.additionalSettings.phoneVerifyEnabled //верификация телефона включена
                    &&  current === 0) //текущий этап - проверка имейла
                {
                    setError("")
                    setCurrent(1)
                    return
                }

                if (e.response.data !== 'Invalid email code' //код email верный
                    && !props.additionalSettings.phoneVerifyEnabled //верификация телефона выключена
                    && props.additionalSettings.twoFaVerifyEnabled //верификация 2fa включена
                    &&  current !== 2 //текущий этап - не проверка 2fa
                )
                {
                    setError("")
                    setCurrent(2)
                    return
                }

                if (props.additionalSettings.phoneVerifyEnabled //верификация телефона включена
                    && e.response.data !== 'Invalid sms code' //код смс верный
                    && props.additionalSettings.twoFaVerifyEnabled  //верификация 2fa включена
                    && current === 1) //текущий этап - проверка смс
                {
                    setError("")
                    setCurrent(2)
                    return
                }

                if (e.response.data === 'Invalid 2fa code') {
                    setError("Invalid 2fa code")
                }
            })
            .finally(() => {
                dispatch(setDisabled(false))
            })
        ;
    };

    const handleNavigate = () => {
        setIsErrorPopupOpen(false)
        setErrorText("")
        props.setCurrent(0)
    }

    const steps = [
        {
            content: <EmailAutenticationLogin
                error={error}
                dataForSend={props.dataForSend}
                setDataForSend={props.setDataForSend}
                sendLoginData={sendLoginData}
                returnToLogin={props.setCurrent}
                setIsErrorModalOpen={props.setIsErrorModalOpen}
            />
        },
        {
            content: <SmsAuntification
                error={error}
                dataForSend={props.dataForSend}
                setDataForSend={props.setDataForSend}
                sendLoginData={sendLoginData}
            />
        },
        {
            content: <TwoFa
                error={error}
                setDataForSend={props.setDataForSend}
                dataForSend={props.dataForSend}
                sendLoginData={sendLoginData}
            />
        },
    ];

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >

            <CustomModal isModalOpen={isErrorPopupOpen} type={"error"}>
                <div className={styles.img_block}>
                    <img src={close_circle} alt=""/>
                </div>
                <div className={styles.popup_title}>
                    {errorText}
                </div>
                <div className={styles.modal_text}>
                    Please contact <a href="mailto:support@luxpay.lt" className={styles.link}>support@luxpay.lt.</a>
                </div>
                <div className={styles.popup_button_wrapper}>
                    <div className={styles.button_block}>
                        <MyBtn isPersonalAccountBtn buttonType={"error"} title={"Ok"}
                               onClick={handleNavigate}/>
                    </div>
                </div>
            </CustomModal>

            <div className={s.wrapper}>

                <div className={s.form_wrapper}>
                    {steps[current].content}

                    <div className={s.btn_block}>
                        <div className={s.btn_wrapper}>
                            <MyBtn title={"Authorize"} large isPersonalAccountBtn onClick={(e) => sendLoginData(e)}/>
                        </div>
                    </div>
                    {/* <div className={s.forget_credentials}>
                        If you forgot your login credentials, please contact&nbsp;
                        <a href="mailto:support@luxpay.lt">support@luxpay.lt</a>
                    </div> */}
                    <div className={s.back}>
                        Back to <span className={s.link} onClick={() => props.setCurrent(0)}>Sign In</span>
                    </div>
                    <div className={s.steps}><Steps quantity={3} activeNum={1} /></div>
                </div>
            </div>

        </motion.div>
    );
};

export default AutenticationStep;
